export type TemplatePageCategoryModel = {
  allow_category_mix: boolean,
  brand_id?: number,
  cache_key: number,
  global: boolean,
  hidden: boolean,
  id: number,
  title: string,
}

export type TemplatePageCategoryRequestOptions = {
  include_template_page_category_brand: boolean,
}

const state = {
  allow_category_mix: false,
  brand_id: undefined,
  global: false,
  hidden: false,
  id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'brand_id', validation: (brandId: number, { global }: TemplatePageCategoryModel) => global || !!brandId },
]

export default state
